// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3ZiDG","modalFooterButton":"ModalNotes_modalFooterButton__31VXI"};